import React, { useContext } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import Recived from "./Recived";
import Send from "./Send";
import JofOffer from "./JofOffer";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import MyJobOffer from "./My-request-jobs";
import RecivedRequests from "./RecivedRequests";
import RequestResponseUser from "./RequestResponseUser";

const Offer = () => {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();

  return (
    <div>
      <div
        className={` w-full px-2 md:px-6  ${
          theme == "dark" ? "bg-black text-white" : "bg-white text-gray-400"}`}
      >
        <div className="flex flex-row  font-pop items-center">
          <Link to={"/user-dashboard/offers/received"}>
            <h2
              className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium  border-b-4 ${
                location.pathname == "/user-dashboard/offers/received"
                  ? "border-primarygreen"
                  : "border-transparent"
              }`}
            >
              Received
            </h2>
          </Link>
          <Link to={"/user-dashboard/offers/send"}>
            <h2
              className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium  border-b-4 ${
                location.pathname == "/user-dashboard/offers/send"
                  ? "border-primarygreen"
                  : "border-transparent"
              }`}
            >
              Sent
            </h2>
          </Link>
          <Link to={"/user-dashboard/offers/job-requests"}>
            <h2
              className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium border-b-4 ${
                location.pathname == "/user-dashboard/offers/job-requests"
                  ? "border-primarygreen"
                  : "border-transparent"
              }`}
            >
              Job requests
            </h2>
          </Link>
          <Link to={"/user-dashboard/offers/my-job-requests"}>
            <h2
                className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium border-b-4 ${
                    location.pathname.includes("/user-dashboard/offers/my-job-requests")
                        ? "border-primarygreen"
                        : "border-transparent"
                }`}
            >
              My Job requests
            </h2>
          </Link>
        </div>
      </div>
      <div className="py-6 md:py-10 max-w-[95%] md:max-w-[95%] m-auto">
        <Routes>
          <Route path="/received" element={<Recived />} />
          <Route path="/send" element={<Send />} />
          <Route path="/job-requests" element={<JofOffer />} />
          <Route path="/my-job-requests" element={<MyJobOffer />} />
          <Route path="/my-job-requests/:jobId" element={<RecivedRequests />} />
          <Route path="/my-job-requests/user-info/:jobId/:userId" element={<RequestResponseUser />}></Route>
        </Routes>
      </div>
    </div>
  );
};

export default Offer;
